<template>
	<div style="height: 100%;">
		<page id="top" v-if="$route.path == '/search'">
			<zui-header></zui-header>
			<div class="search">
				<PageNavigater></PageNavigater>
				<div class="contain">
					<div class="kuang flex">
						<div class="search-left flex">
							<div class="search-icon"></div>
							<input type="text" v-model="searchKey" maxlength="10" placeholder="输入关键词搜素"
								@keydown.enter="searchArticleList" />
						</div>
						<div class="search-right" @click="searchArticleList">点击搜索</div>
					</div>
					<div class="list" v-if="list.length>0">
						<div class="list-title">搜索结果<span>共{{ total }}条结果</span></div>
						<a class="data-item" :class="isIE ? 'classie' : ''" v-for="item in list" :key="item.id" @click="gotoDetail(item)">
							<div class="img">
								<cms-image :src="item.cover"></cms-image>
							</div>
							<div class="rightContent">
								<div class="artile-title" v-html="item.title">
								</div>
								<div class="artile-content" v-html="item.intro">
								</div>
								<a class="artile-detail">查看详情</a>
							</div>
						</a>
					</div>
					<div class="empty" v-else>暂无搜索结果,请重新输入关键词</div>

					<div class="page" v-show="list.length > 0">
						<el-pagination background layout="prev, pager, next" :page-size="limit" :total="total"
							@current-change="pageChange">
						</el-pagination>
					</div>
				</div>
			</div>
			<ZuiFooter />
		</page>
		<router-view v-else></router-view>
	</div>
</template>

<script>
	import './less/search.css'
	import {
		searchArticles
	} from "~/api/CmsApi";

	export default {
		data() {
			return {
				searchKey: '',
				page: 1,
				limit: 6,
				total: 0,
				cmsImg1: require('~/assets/img/list-img.jpg'),
				list: [],
				isIE: false
			}
		},
		mounted() {
			if (document.documentMode)
				this.isIE = true;
		},
		methods: {
			gotoDetail(item) {
				// this.searchKey = '';
				this.$openNewWindow('/new/search/info?id=' + item.id)
			},
			pageChange(page) {
				this.page = page;
				this.searchArticleList();
			},
			searchArticleList() {
				if (this.searchKey.trim() === '') {
					this.list = [];
					return;
				}

				const param = {
					page: this.page,
					limit: this.limit,
					searchKey: this.searchKey.trim()
				}
				searchArticles(param).then(res => {
					this.total = res.data.total;
					this.list = res.data.records.map(item => {
						const reg = new RegExp(this.searchKey, 'ig');
						if (item.title) {
							item.title = item.title.replace(reg,
								`<span class="ht">${this.searchKey}</span>`);
						}
						if (item.intro) {
							item.intro = item.intro.replace(reg,
								`<span class="ht">${this.searchKey}</span>`);
						}
						return item;
					});
					console.log(this.list);
				});
			}
		}
	}
</script>

<style>
	.search{
		background-color: white;
	}
</style>



// WEBPACK FOOTER //
// src/views/search.vue